module.exports = __webpack_public_path__ + "static/media/edit.06f29300.svg";